/**
 * Posts user activity for CLOB procedure, diagnosis, and coverageControl changes.
 * @param {string} healthPlanKey - The health plan key associated with the activity.
 * @param {string} policyKey - The policy key associated with the activity.
 * @param {string} statusCode - The status code for API Call you are recording activity for.
 * @param {string} workFlow - The workflow associated with the activity.
 * @param {string} page - The page where the activity occurred.
 * @param {string} appCreateDatetime - The application creation date and time.
 * @param {string} policyVersion - The version of the policy.
 * @param {string} changeControlNumber - The change control number.
 * @param {string} ruleName - The name of the rule.
 * @param {string} code - procedureCode, diagnosisCode, or coverageControl.
 * @param {string} action - Details of change to code typically "add", or "delete".
 * @param {string} type - The type of code (e.g., "procedureCode", "diagnosisCode", "coverageControl").
 * @param {Array} userActivityDtoArray - The array to which the user activity DTO will be added.
 * @param {string} [ruleFlowGroup] - Optional rule flow group associated with the activity.
 * @return {Array} The updated user activity DTO array.
 * @throws Will throw an error if the API call fails.
 */
const updateActivityTrackerArrayforClob = (
  healthPlanKey,
  policyKey,
  statusCode,
  workFlow,
  page,
  policyVersion,
  changeControlNumber,
  ruleName,
  code,
  action,
  type,
  userActivityDtoArray,
  ruleFlowGroup
) => {
  const eventStream = {
    policyVersion: policyVersion,
    changeControlNumber: changeControlNumber,
    ruleName: ruleName,
    code: code,
    action: action,
    type: type,
    ...(ruleFlowGroup && { ruleFlowGroup: ruleFlowGroup }),
  };

  const userActivityDto = {
    healthPlanKey: healthPlanKey,
    policyKey: policyKey,
    eventStream: JSON.stringify(eventStream),
    statusCode: statusCode,
    source: "UI",
    workflow: workFlow,
    page: page,
    appCreateDatetime: new Date()
      .toISOString()
      .replace("T", " ")
      .substring(0, 19), // "yyyy-MM-dd HH:mm:ss"
  };

  // Add the user activity DTO to the array
  userActivityDtoArray.push(userActivityDto);

  return userActivityDtoArray;
};

export { updateActivityTrackerArrayforClob };
